import { TooltipProps } from 'antd';
import Tooltip from 'antd/es/tooltip';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { StatusType } from './Status.constants';
import s from './Status.module.less';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  type?: StatusType;
  shape?: 'round' | 'square';
  uppercase?: boolean;
  size?: 'small' | 'medium' | 'large';
  outline?: boolean;
  tooltip?: React.ReactNode;
  tooltipProps?: TooltipProps;
  'data-testid'?: string;
  'data-testvalue'?: string;
};

export const Status: React.FC<Props> = (props) => {
  const {
    className,
    children,
    size = 'medium',
    outline,
    type = StatusType.Blue,
    uppercase,
    tooltip,
    tooltipProps,
    shape = 'round',
    ...rest
  } = props;

  return (
    <Tooltip {...tooltipProps} title={tooltip} overlayClassName={clsx(s.tooltip, tooltipProps?.overlayClassName)}>
      <div
        {...rest}
        className={clsx(className, s.root, s[size], s[type], {
          [s.outline]: outline,
          [s.uppercase]: uppercase,
          [s[shape]]: shape,
        })}
      >
        {children}
      </div>
    </Tooltip>
  );
};
